<script>
  import { setContext, onMount } from 'svelte';

  export let duration = 1000;
  export let easing = "linear";

  export const play = () => {
    triggers.forEach((t) => {
      t(1);
    });
  };

  export const reset = () => {
    triggers.forEach((t) => {
      t(0);
    });
  };



  let triggers = [];

  setContext("addTrigger", (t) => {
    triggers.push(t);
  });


  setContext("getDuration", () => duration);
  setContext("getEasing", () => easing);

</script>

<div class="animation-css anim-css-c">
  <slot></slot>
</div>

